import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

import { Link, useNavigate } from 'react-router-dom';

export default function SimpleBottomNavigation() {
  const [value, setValue] = React.useState(0);
  let navigate = useNavigate();
  
  return (
    <Box sx={{ width: 500 }}>
	
	  <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: "10" }} elevation={3}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction label="Home" icon={<HomeOutlinedIcon /> } onClick={() => {navigate('/home')}} />
		<BottomNavigationAction label="Explore" icon={<SearchOutlinedIcon />} onClick={() => {navigate('/explore')}} />
		<BottomNavigationAction label="Notifications" icon={<NotificationsOutlinedIcon />} onClick={() => {navigate('/notification')}} />
		<BottomNavigationAction label="Message" icon={<MailOutlinedIcon />} onClick={() => {navigate('/message')}}/>
	  </BottomNavigation>
	  
	  </Paper>
    </Box>
  );
}
